import { useViewPort } from './useViewPort';
/**
 * Whether or not the viewport dimension is equal to or less than mobile
 *
 * @param {number} breakpoint The width in px at which point the resolution is considered mobile
 * @example
 * const mobile = useMobile();
 * console.log(`Your viewport is ${mobile ? 'below' : 'above'} mobile`);
 */
export var useMobile = function (breakpoint) {
    var mobile = useViewPort({ mobile: breakpoint }).mobile;
    return mobile;
};
